<template>
    <div component="doc">
        <div class="content">
            <section class="header">
                <h1>Typografia</h1>
            </section>
            <section>
                <div class="name">
                    <h2><span>Attribute:</span>Name</h2>
                </div>
                <div class="content">
                    <div class="demo">
                        <div class="desc" contenteditable="">size="big"</div>
                        <p>TypographyDoc</p>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TypographyDoc',
};
</script>

<style lang="less" scoped></style>
